let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hZ95g")).then(() => parcelRequire('5YJ1A'));